export const SocketType = {
  SET_SOCKET_STATUS: "SET_SOCKET_STATUS",
  SET_SOCKET_DATA: "SET_SOCKET_DATA",
  UPDATEPRODUCTSTATUS: "UPDATEPRODUCTSTATUS",
  COMPLETEORDER: "COMPLETEORDER",
};
